import React from "react";

const Join = () => {
  return (
    <div id="join" className="join">
      <div className="container pt-5 pb-5">
        <div className="row align-items-center pt-5 pb-5 justify-content-center">
          <div className="col-lg-12 pt-5 pb-5">
            <h2 className="text-center">
              Join the <span style={{ color: " #7D6CFF" }}>Infinet</span>{" "}
              Community
            </h2>
            <div className="d-flex pt-5 pb-5 align-items-center justify-content-center gap-4">
              <svg
                width="44"
                height="45"
                viewBox="0 0 44 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M33.5981 4.29004H39.7828L26.2711 19.7331L42.1666 40.7477H29.7205L19.9723 28.0024L8.81816 40.7477H2.62971L17.0819 24.2295L1.83325 4.29004H14.5953L23.4068 15.9396L33.5981 4.29004ZM31.4275 37.0458H34.8545L12.7331 7.79745H9.0556L31.4275 37.0458Z"
                  fill="white"
                />
              </svg>
              <svg
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.0391 0.799316H2.95312C1.32031 0.799316 0 2.08838 0 3.68213V37.9087C0 39.5024 1.32031 40.7993 2.95312 40.7993H37.0391C38.6719 40.7993 40 39.5024 40 37.9165V3.68213C40 2.08838 38.6719 0.799316 37.0391 0.799316ZM11.8672 34.8853H5.92969V15.7915H11.8672V34.8853ZM8.89844 13.1899C6.99219 13.1899 5.45312 11.6509 5.45312 9.75244C5.45312 7.854 6.99219 6.31494 8.89844 6.31494C10.7969 6.31494 12.3359 7.854 12.3359 9.75244C12.3359 11.6431 10.7969 13.1899 8.89844 13.1899ZM34.0859 34.8853H28.1562V25.604C28.1562 23.3931 28.1172 20.5415 25.0703 20.5415C21.9844 20.5415 21.5156 22.9556 21.5156 25.4478V34.8853H15.5938V15.7915H21.2812V18.4009H21.3594C22.1484 16.9009 24.0859 15.3149 26.9688 15.3149C32.9766 15.3149 34.0859 19.2681 34.0859 24.4087V34.8853Z"
                  fill="white"
                />
              </svg>
              <svg
                width="44"
                height="45"
                viewBox="0 0 44 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.2479 8.41779C34.4434 7.131 31.4361 6.18296 28.2918 5.63997C28.2346 5.62949 28.1774 5.65568 28.1479 5.70806C27.7611 6.39596 27.3327 7.29337 27.0327 7.99873C23.6507 7.49242 20.2862 7.49242 16.9736 7.99873C16.6735 7.27769 16.2296 6.39596 15.8411 5.70806C15.8116 5.65743 15.7544 5.63124 15.6971 5.63997C12.5545 6.18122 9.54719 7.12927 6.74105 8.41779C6.71675 8.42826 6.69593 8.44574 6.68211 8.46842C0.977885 16.9904 -0.584742 25.3029 0.18183 33.5124C0.185299 33.5526 0.207845 33.591 0.239063 33.6154C4.00255 36.3792 7.64813 38.0571 11.226 39.1693C11.2833 39.1867 11.3439 39.1658 11.3804 39.1186C12.2267 37.9629 12.9812 36.7442 13.628 35.4626C13.6662 35.3876 13.6298 35.2985 13.5518 35.2688C12.3551 34.8149 11.2156 34.2614 10.1195 33.6329C10.0328 33.5823 10.0259 33.4583 10.1056 33.3989C10.3363 33.226 10.567 33.0462 10.7873 32.8646C10.8271 32.8315 10.8826 32.8245 10.9295 32.8454C18.1304 36.1331 25.9262 36.1331 33.0421 32.8454C33.0889 32.8227 33.1445 32.8297 33.186 32.8629C33.4064 33.0445 33.637 33.226 33.8694 33.3989C33.9492 33.4583 33.944 33.5823 33.8573 33.6329C32.7612 34.2736 31.6217 34.8149 30.4233 35.2671C30.3452 35.2968 30.3105 35.3876 30.3487 35.4626C31.0095 36.7424 31.7639 37.9611 32.5946 39.1169C32.6293 39.1658 32.6918 39.1867 32.749 39.1693C36.3442 38.0571 39.9898 36.3792 43.7533 33.6154C43.7863 33.591 43.8071 33.5543 43.8106 33.5141C44.728 24.0231 42.2739 15.7787 37.3051 8.47015C37.2929 8.44574 37.2722 8.42826 37.2479 8.41779ZM14.7034 28.5137C12.5354 28.5137 10.7491 26.5234 10.7491 24.079C10.7491 21.6346 12.5008 19.6443 14.7034 19.6443C16.9233 19.6443 18.6923 21.6521 18.6576 24.079C18.6576 26.5234 16.9059 28.5137 14.7034 28.5137ZM29.3237 28.5137C27.1558 28.5137 25.3695 26.5234 25.3695 24.079C25.3695 21.6346 27.1211 19.6443 29.3237 19.6443C31.5437 19.6443 33.3126 21.6521 33.278 24.079C33.278 26.5234 31.5437 28.5137 29.3237 28.5137Z"
                  fill="white"
                />
              </svg>
              <svg
                width="38"
                height="34"
                viewBox="0 0 38 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.8005 23.0984L27.8657 8.97966L10.514 21.5507C10.2233 21.7613 9.84211 21.8 9.5151 21.652L0.713105 17.6702C-0.0879402 17.3078 -0.0650898 16.1624 0.749771 15.8322L37.4131 0.978027L32.3732 33.1289C32.2623 33.8365 31.4651 34.2015 30.8569 33.823L16.0323 24.5971C15.5128 24.2738 15.4029 23.5637 15.8005 23.0984Z"
                  fill="white"
                />
              </svg>
            </div>
            <p>Signup for our newsletter for latest updates</p>
            <div className="d-flex header-btn align-items-center justify-content-center gap-4 pt-4">

            <div className="input-groups">
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M15.8334 3.63281H4.16675C3.50371 3.63281 2.86782 3.8962 2.39898 4.36505C1.93014 4.83389 1.66675 5.46977 1.66675 6.13281V14.4661C1.66675 15.1292 1.93014 15.7651 2.39898 16.2339C2.86782 16.7028 3.50371 16.9661 4.16675 16.9661H15.8334C16.4965 16.9661 17.1323 16.7028 17.6012 16.2339C18.07 15.7651 18.3334 15.1292 18.3334 14.4661V6.13281C18.3334 5.46977 18.07 4.83389 17.6012 4.36505C17.1323 3.8962 16.4965 3.63281 15.8334 3.63281V3.63281ZM15.4917 5.29948L10.5917 10.1995C10.5143 10.2776 10.4221 10.3396 10.3206 10.3819C10.219 10.4242 10.1101 10.446 10.0001 10.446C9.89007 10.446 9.78115 10.4242 9.6796 10.3819C9.57805 10.3396 9.48588 10.2776 9.40842 10.1995L4.50841 5.29948H15.4917ZM16.6667 14.4661C16.6667 14.6872 16.579 14.8991 16.4227 15.0554C16.2664 15.2117 16.0544 15.2995 15.8334 15.2995H4.16675C3.94573 15.2995 3.73377 15.2117 3.57749 15.0554C3.42121 14.8991 3.33341 14.6872 3.33341 14.4661V6.47448L8.23342 11.3745C8.70217 11.8426 9.33758 12.1056 10.0001 12.1056C10.6626 12.1056 11.298 11.8426 11.7667 11.3745L16.6667 6.47448V14.4661Z"
                    fill="#F8F8FA"
                  />
                </g>
              </svg>

              <input type="text" placeholder="Enter email" />
            </div>
            <button className="btn-bg">
              Subscribe{" "}
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9117 12.12C17.8641 11.9973 17.7927 11.8851 17.7017 11.79L12.7017 6.79C12.6085 6.69676 12.4978 6.6228 12.3759 6.57234C12.2541 6.52188 12.1236 6.49591 11.9917 6.49591C11.7254 6.49591 11.47 6.6017 11.2817 6.79C11.1885 6.88324 11.1145 6.99393 11.064 7.11575C11.0136 7.23758 10.9876 7.36814 10.9876 7.5C10.9876 7.7663 11.0934 8.0217 11.2817 8.21L14.5817 11.5H6.9917C6.72648 11.5 6.47213 11.6054 6.28459 11.7929C6.09706 11.9804 5.9917 12.2348 5.9917 12.5C5.9917 12.7652 6.09706 13.0196 6.28459 13.2071C6.47213 13.3946 6.72648 13.5 6.9917 13.5H14.5817L11.2817 16.79C11.188 16.883 11.1136 16.9936 11.0628 17.1154C11.012 17.2373 10.9859 17.368 10.9859 17.5C10.9859 17.632 11.012 17.7627 11.0628 17.8846C11.1136 18.0064 11.188 18.117 11.2817 18.21C11.3747 18.3037 11.4853 18.3781 11.6071 18.4289C11.729 18.4797 11.8597 18.5058 11.9917 18.5058C12.1237 18.5058 12.2544 18.4797 12.3763 18.4289C12.4981 18.3781 12.6087 18.3037 12.7017 18.21L17.7017 13.21C17.7927 13.1149 17.8641 13.0028 17.9117 12.88C18.0117 12.6365 18.0117 12.3635 17.9117 12.12Z"
                  fill="white"
                />
              </svg>
            </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Join;
